<template>
  <!-- 分享 -->
  <div v-if="showShareMask" class="mask" @click="hideMask">
    <div class="guide">
      <img src="@/assets/svg/share_guide.svg" alt />
    </div>
    <div class="mask_c">
      <div class="hint1">1. 点击右上角</div>
      <div class="hint2">
        <span>2. 点击</span>
        <img src="@/assets/svg/share_friend.svg" alt />
        <span>发送给朋友或</span>
        <img src="@/assets/svg/share_timeline.svg" alt />
        <span>发送给朋友圈</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showShareMask: true
    };
  },
  methods: {
    hideMask() {
      this.showShareMask = true;
      this.$emit("hideMask");
    }
  }
};
</script>
<style lang="less" scoped>
/* 微信内遮罩层提示分享 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.guide {
  float: right;
  padding: 4px 12px;
}
.guide img {
  width: 88px;
}
.mask_c {
  background: #fff;
  margin: 128px 24px auto 24px;
  border-radius: 5px;
  padding: 12px;
  font-size: 14px;
  color: #222;
}
.hint1 {
  padding: 4px 0;
}
.hint2 {
  display: flex;
  flex-direction: row;
}
.hint2 span {
  margin: auto 0;
}
.hint2 img {
  width: 16px;
  height: 16px;
  margin: auto 0;
}
</style>
